import React from 'react'
import './aboutbanner.scss'
import { useTheme } from '../../../contexts/ThemeProvider'
import { LIGHT_THEME } from '../../../utils/constants';

const AboutBanner = () => {
    const { theme } = useTheme();



    return (
        <>
            <div className="aboutbanner_bg">
                <img
                    src="\assets\homepage\banner\banner-shadow.png"
                    alt="img"
                    className="img-fluid banner-shadow"
                />
                <video
                    className="main-banner-video"
                    muted="muted"
                    playsinline="playsinline"
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo"
                >
                    <source src="\assets\bannervideo.mp4" type="video/mp4" />
                </video>

                <div className="custom-container aboutbanner_main">

                    <div className="aboutbanner_left">

                        <h2>About Us</h2>
                        <p>
                            Rain is a decentralized prediction markets protocol designed to be the “Uniswap of prediction markets.” Built natively on Arbitrum with cross-chain support, Rain is an open protocol that empowers anyone to create and trade markets. Combining automated market makers, Rain ensures liquidity while aligning incentives for creators, resolvers, and liquidity providers.
                            <span>
                                Fully permissionless, borderless, and decentralized, Rain is building the infrastructure for prediction markets at global scale.
                            </span>
                        </p>

                    </div>

                    {window.innerWidth > 991 ? (
                        <img
                            src="/assets/about/aboutbanner.png"
                            alt="bannerimg"
                            className="w-full h-auto"
                        />
                    ) : (
                        <img
                            src="/assets/about/banner-mb.png"
                            alt="bannerimg"
                            className="w-full h-auto"
                        />
                    )}

                </div>

                {theme != LIGHT_THEME ? <div className="shadow"></div> : ""}

            </div>

        </>
    )
}

export default AboutBanner